export default "__VITE_PUBLIC_ASSET__416c2819__"